import { ReduxStore } from 'store/types';

function getDetailsTimelineActiveActionIndex(state: ReduxStore): number {
  return state.intervention.getDetails.activeTimelineActionIndex;
}

export default getDetailsTimelineActiveActionIndex;
